import * as React from 'react';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress'; // Added for visual feedback
import fetchData from '../../actions/utils/fetchData';
import { useValue } from '../../context/ContextProvider';
import { useEffect, useState } from 'react';

export default function Sizes() {
  const {
    state: { filteredTags },
    dispatch
  } = useValue();

  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false); // Step 1: Initialize loading state
  const url = process.env.REACT_APP_SERVER_PROD_URL + '/tag';

  useEffect(() => {
    const retrieveTags = async () => {
      setLoading(true); // Start loading
      try {
        const tagsResponse = await fetchData({ url, method: 'GET' });
        if (tagsResponse) {
          const uniqueTags = tagsResponse.reduce((map, tag) => {
            if (!map.has(tag.title) || new Date(tag.updatedAt) > new Date(map.get(tag.title).updatedAt)) {
              map.set(tag.title, tag);
            }
            return map;
          }, new Map());

          const processedTags = Array.from(uniqueTags.values());
          processedTags.sort((a, b) => a.title.localeCompare(b.title));
          setTags(processedTags);
        }
      } catch (error) {
        console.error("Error fetching tags:", error);
      } finally {
        setLoading(false); // Step 1: Stop loading regardless of success/fail
      }
    };
    retrieveTags();
  }, [url]);

  const handleAutocompleteChange = (value) => {
    dispatch({ type: 'UPDATE_FILTERED_TAGS', payload: value });
  };

  return (
    <Stack spacing={2} sx={{ width: 400 }}>
      <Autocomplete
        multiple
        id="size-small-standard-multi"
        size="small"
        loading={loading} // Bind loading prop
        options={tags}
        value={filteredTags || []} 
        onChange={(event, value) => { handleAutocompleteChange(value); }}
        
        // Defensive check: prevents "t is not a function" if data is undefined
        isOptionEqualToValue={(option, value) => 
          option?._id === value?._id
        }
        
        // Defensive check: ensures we always return a string
        getOptionLabel={(option) => 
          typeof option === 'string' ? option : option?.title || ''
        }

        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="Select your Tags"
            placeholder="Add Another Tag"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Stack>
  );
}
